import { useId } from "react";

// Marca do produto: um marca-página que vira estrela.
// O bookmark é o estudo ("marcar o ponto onde você está"); a estrela de 4 pontas
// é a faísca do entendimento. Símbolo próprio — nada de ícone genérico de IA.
export function Spark({ className = "h-6 w-6", animated = false }) {
  const gid = useId();
  return (
    <div className={`relative inline-flex items-center justify-center ${className}`}>
      <div className="absolute inset-0 rounded-full bg-violet-500/25 blur-md" />
      <svg
        viewBox="0 0 48 48"
        className={`relative h-full w-full ${animated ? "animate-pulse" : ""}`}
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        aria-label="Sagaz"
      >
        <defs>
          <linearGradient id={gid} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#a78bfa" />
            <stop offset="100%" stopColor="#7c3aed" />
          </linearGradient>
        </defs>
        {/* marca-página */}
        <path
          d="M13 3.5h22c3 0 5.5 2.5 5.5 5.5v33.6c0 1.7-1.9 2.7-3.3 1.7L24 35.9 10.8 44.3c-1.4 1-3.3 0-3.3-1.7V9c0-3 2.5-5.5 5.5-5.5z"
          fill={`url(#${gid})`}
        />
        {/* estrela de 4 pontas (faísca do entendimento) */}
        <path
          d="M24 10c1.3 5.4 3.3 7.4 8.7 8.7-5.4 1.3-7.4 3.3-8.7 8.7-1.3-5.4-3.3-7.4-8.7-8.7 5.4-1.3 7.4-3.3 8.7-8.7z"
          fill="#fff"
        />
      </svg>
    </div>
  );
}

export function SparkLogo({ size = "default" }) {
  const sizes = { sm: "h-7", default: "h-9", lg: "h-12" };
  const textSizes = { sm: "text-base", default: "text-xl", lg: "text-2xl" };
  return (
    <div className="flex items-center gap-2.5">
      <Spark className={`${sizes[size]} aspect-square`} />
      <span className={`font-bold tracking-tight ${textSizes[size]}`}>Sagaz</span>
    </div>
  );
}
